// Analytics Controller
// Handles analytics-related API operations

import { post } from './utilitiesController.js';

/**
 * Get engagements grouped by date
 * @param {Object} data - Data containing start_date and end_date
 * @returns {Promise} - Response from engagements-by-date endpoint
 */
export const getEngagementsByDate = async (data) => {
    try {
        const response = await post('api/analytics/engagements-by-date', data, true);
        return response;
    } catch (error) {
        console.error('Failed to get engagements by date:', error);
        throw error;
    }
};

export default {
    getEngagementsByDate
};
